import React, { useState, useEffect } from "react";
import "./Artifacts.css";
import api from "../api/axios";
import { toast } from "react-toastify";
const Artifacts = () => {

  // ✅ UNCHANGED — all original state
  const [showDetail, setShowDetail] = useState(false);
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [artifacts, setArtifacts] = useState([]);
  const [selectedArtifact, setSelectedArtifact] = useState(null); // Not used in current render logic
  const [loadingAgents, setLoadingAgents] = useState(true);
  const [loading, setLoading] = useState(false);

  // ✅ NEW UI STATE ONLY — counts per agent (purely display, no backend change)
  const [agentCounts, setAgentCounts] = useState({}); // { agent_id: { images: N, docs: N } }

  const [openMenuId, setOpenMenuId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    const closeMenu = () => setOpenMenuId(null);
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  // ===============================
  // ✅ UNCHANGED — FETCH AGENTS
  // ===============================
  const fetchAgents = async () => {
    setLoadingAgents(true);
    try {
      const res = await api.get("/artifacts/agents");
      setAgents(res.data);

      // ✅ NEW UI ONLY: fetch file type breakdown per agent for pill badges
      // Uses existing backend endpoint /artifacts/agent/:agentId — zero new API needed
      res.data.forEach(async (agent) => {
        try {
          const filesRes = await api.get(`/artifacts/agent/${agent.agent_id}`);
          const files = filesRes.data;
          const images = files.filter(f => f.type === "image").length;
          const docs = files.filter(f => f.type !== "image").length;
          setAgentCounts(prev => ({
            ...prev,
            [agent.agent_id]: { images, docs }
          }));
        } catch {
          // silently skip — pill just shows 0
        }
      });

    } catch (err) {
      console.error("Fetch agents failed", err);
    } finally {
      setLoadingAgents(false);
    }
  };

  // ===============================
  // ✅ UNCHANGED — FETCH FILES BY AGENT
  // ===============================
  const fetchAgentArtifacts = async (agentId) => {
    try {
      setLoading(true);
      const res = await api.get(`/artifacts/agent/${agentId}`);
      setArtifacts(res.data);
      if (res.data.length > 0) {
        setSelectedArtifact(res.data[0]);
      }
    } catch (err) {
      console.error("Fetch artifacts failed", err);
    } finally {
      setLoading(false); // This 'loading' state is for artifacts detail view
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  // ✅ UPDATED — fetch blob to force local download instead of opening in new tab
  const handleDownload = async (url, fileName = "document") => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download failed via fetch, falling back to open tab:", err);
toast.info("Opening file in a new tab...");
      window.open(url, "_blank");
    }
  };

  // ===============================
  // ✅ DETAIL VIEW — new grid layout per design
  // ===============================
  if (showDetail) {
    const images = artifacts.filter(f => f.type === "image");
    const docs = artifacts.filter(f => f.type !== "image");

    return (
      <div className="art-detail-wrap">

        {/* Header */}
        <div className="art-detail-header">
          <div>
            <h5 className="art-detail-title">{selectedAgent?.agent_name}</h5>
            <p className="art-detail-sub">Get all your generated files and images</p>
          </div>
          <button
            className="art-back-btn"
            onClick={() => {
              setShowDetail(false);
              setSelectedArtifact(null);
              setArtifacts([]);
            }}
          >
            <i className="bi bi-arrow-left" /> Back
          </button>
        </div>

        {/* Files grid */}
        {loading ? ( // This 'loading' state is for artifacts detail view
          <div className="art-loading">
            <div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div>
          </div>
        ) : artifacts.length === 0 && !loading ? (
          <div className="art-empty">
            <i className="bi bi-folder-x" style={{ fontSize: '2rem', opacity: 0.4 }} />
            <p>No files found for this agent.</p>
          </div>
        ) : (
          <div className="art-files-grid">
            {artifacts.map((item) => (
              <div key={item.id} className="art-file-card position-relative">
                {/* Three dots */}
                <div 
                  className="art-file-dots"
                  onClick={(e) => {
                    e.stopPropagation();
                    setOpenMenuId(openMenuId === item.id ? null : item.id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-three-dots-vertical" />
                </div>

                {/* Dropdown Menu */}
                {openMenuId === item.id && (
                  <div 
                    className="dropdown-menu show position-absolute shadow-sm" 
                    style={{ top: '35px', right: '10px', zIndex: 100 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item.type === "image" ? (
                      <>
                        <button className="dropdown-item d-flex align-items-center gap-2" onClick={() => { setPreviewImage(item); setOpenMenuId(null); }}>
                          <i className="bi bi-eye"></i> Preview Image
                        </button>
                        <button className="dropdown-item d-flex align-items-center gap-2" onClick={() => { handleDownload(item.file_url, item.file_name); setOpenMenuId(null); }}>
                          <i className="bi bi-download"></i> Download Image
                        </button>
                      </>
                    // REPLACE WITH:
) : (
  <>
    <button className="dropdown-item d-flex align-items-center gap-2" onClick={() => { setPreviewImage(item); setOpenMenuId(null); }}>
      <i className="bi bi-eye"></i> Preview Document
    </button>
    <button className="dropdown-item d-flex align-items-center gap-2" onClick={() => { handleDownload(item.file_url, item.file_name); setOpenMenuId(null); }}>
      <i className="bi bi-download"></i> Download PDF
    </button>
  </>
)}
                  </div>
                )}

                {/* Preview area */}
                <div className="art-file-preview">
                  {item.type === "image" ? (
                    <img
                      src={item.file_url}
                      alt={item.file_name}
                      className="art-file-thumb"
                      onError={(e) => {
                        e.target.style.display = "none";
                        e.target.nextSibling.style.display = "flex";
                      }}
                    />
                  ) : null}
                  {/* Fallback / doc icon */}
                  <div
                    className="art-file-icon-wrap"
                    style={{ display: item.type === "image" ? "none" : "flex" }}
                  >
                    {item.type === "image" ? (
                      <img src="/images/newarti.svg" alt="" className="art-file-type-icon" />
                    ) : (
                      <img src="/images/newarti2.svg" alt="" className="art-file-type-icon" />
                    )}
                  </div>
                </div>

                {/* File name + date */}
                <div className="art-file-meta">
                  <div className="art-file-name">{item.file_name || "Untitled"}</div>
                  <div className="art-file-date">
                    Last Used : {new Date(item.created_at).toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Preview Modal */}
        {previewImage && (
          <div 
            className="cx-preview-overlay" 
            style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.6)", zIndex: 10000, display: "flex", justifyContent: "center", alignItems: "center" }} 
            onClick={() => setPreviewImage(null)}
          >
            <div 
              className="cx-preview-modal shadow-lg" 
              style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px", maxWidth: "90%", maxHeight: "90%", overflow: "auto" }} 
              onClick={(e) => e.stopPropagation()}
            >
              <div className="d-flex justify-content-between align-items-center mb-3">
                <strong className="fs-5">{previewImage.file_name || "Preview"}</strong>
                <button className="btn btn-sm btn-light rounded-circle" onClick={() => setPreviewImage(null)}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
              {previewImage.type === "image" ? (
  <img 
    src={previewImage.file_url} 
    alt="Preview" 
    style={{ maxWidth: "100%", height: "auto", display: "block", margin: "0 auto" }} 
  />
) : (
  <iframe 
    src={previewImage.file_url} 
    title="Document Preview"
    style={{ width: "70vw", height: "75vh", border: "none" }}
  />
)}
            </div>
          </div>
        )}
      </div>
    );
  }

  // ===============================
  // AGENT CARDS GRID — new design
  // ===============================
  return (
    <div className="art-wrap container-fluid p-4">
      {loadingAgents ? (
        <div className="art-agents-grid placeholder-glow">
          {[...Array(6)].map((_, index) => ( // Render 6 skeleton cards
            <div key={index} className="art-agent-card">
              <div className="art-card-top">
                <div className="art-card-icon-wrap placeholder bg-secondary rounded-circle" style={{ width: '48px', height: '48px' }}></div>
                <div className="art-card-name placeholder bg-secondary col-8"></div>
              </div>
              <div className="art-card-pills">
                <span className="art-pill art-pill--image placeholder bg-secondary col-4"></span>
                <span className="art-pill art-pill--doc placeholder bg-secondary col-4"></span>
              </div>
              <hr className="art-card-divider" />
              <div className="art-card-footer">
                <span className="art-card-lastused placeholder bg-secondary col-6"></span>
                <button className="art-view-btn placeholder bg-primary col-3"></button>
              </div>
            </div>
          ))}
        </div>
      ) : agents.length === 0 ? (
        <div className="art-empty">
          <i className="bi bi-folder-x" style={{ fontSize: '2.5rem', opacity: 0.4 }} />
          <h6>No agents found</h6>
          <p>Create an agent to generate files.</p>
        </div>
      ) : (
        <div className="art-agents-grid">
          {agents.map((agent) => {
            const counts = agentCounts[agent.agent_id] || { images: 0, docs: 0 };

            return (
              <div key={agent.agent_id} className="art-agent-card">

                {/* Three dots top right */}
                <div className="art-card-dots">
                  {/* <i className="bi bi-three-dots-vertical" /> */}
                </div>

                {/* Top section: icon + name */}
                <div className="art-card-top">
                  <div className="art-card-icon-wrap">
                    <img src="/images/newcusact.svg" alt="" className="art-card-icon" />
                  </div>
                  <div className="art-card-name">{agent.agent_name}</div>
                </div>

                {/* Pill badges: images + docs */}
                <div className="art-card-pills">
                  <span className="art-pill art-pill--image">
                    <img src="/images/newarti.svg" alt="" className="art-pill-icon" />
                    {counts.images} Images
                  </span>
                  <span className="art-pill art-pill--doc">
                    <img src="/images/newarti2.svg" alt="" className="art-pill-icon" />
                    {counts.docs} Documents
                  </span>
                </div>

                {/* Divider */}
                <hr className="art-card-divider" />

                {/* Footer: last used + view button */}
                <div className="art-card-footer">
                  <span className="art-card-lastused">
                    Last Used : {agent.last_updated
                      ? new Date(agent.last_updated).toLocaleString()
                      : "—"}
                  </span>
                  <button
                    className="art-view-btn"
                    onClick={() => {
                      setShowDetail(true);
                      setSelectedAgent(agent);
                      fetchAgentArtifacts(agent.agent_id);
                    }}
                  >
                    View
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Artifacts;
           